<script lang="ts">
  import Cookies from 'js-cookie';

  const cookieValue = Cookies.get('_mkto_trk') || 'undefined';
</script>

<input class="fs-exclude" name="_mkt_trk" type="hidden" value={cookieValue} />
